import { Database } from '@vuex-orm/core';
import Address from '@/models/Address';
import DeliveryPeriod from '@/models/DeliveryPeriod';
import Equipment from '@/models/Equipment';
import Material from '@/models/Material';
import Position from '@/models/Position';
import Transaction from '@/models/Transaction';
import Price from '@/models/Price';

const database = new Database();

database.register(Address);
database.register(DeliveryPeriod);
database.register(Equipment);
database.register(Material);
database.register(Position);
database.register(Transaction);
database.register(Price);

export default database;